import React from 'react';
import { UploadProgressIndicator } from './UploadProgressIndicator';
import { useUploadQueue } from '../hooks/useUploadQueue';

export const GlobalUploadProgress: React.FC = () => {
  const {
    progress,
    isVisible,
    cancelFile,
    retryFile,
    clearCompleted,
    hideIndicator,
  } = useUploadQueue();

  return (
    <UploadProgressIndicator
      isVisible={isVisible}
      progress={progress}
      onCancel={cancelFile}
      onRetry={retryFile}
      onClearCompleted={clearCompleted}
      onClose={hideIndicator}
    />
  );
};